import React from 'react'

interface TooltipProps {
  hint: string;
  children: React.ReactNode;
  hintClassName?: string;
  isCustomSettings?: boolean;
  className?: string;
}

const Tooltip: React.FC<TooltipProps> = ({ hint, children, hintClassName = 'left-[50%] bottom-7', isCustomSettings = false, className = '' }) => {
  return (
    <div className={`c-tooltip group relative ${className}`}>
      <div className={`absolute hidden w-auto group-hover:block ${hintClassName}`}>
        <div className={`whitespace-nowrap rounded border border-foggy-mist bg-gray-3 px-1 py-1 text-[10px] leading-[10px] md:px-2 md:text-xs/3 ${isCustomSettings ? '' : 'translate-x-[-50%]'}`}>
          {hint}
        </div>
      </div>
      {children}
    </div>
  )
};

export default Tooltip;
